import { Component } from '@angular/core';

@Component({
    selector: 'app-projects-showcase',
    templateUrl: './projects-showcase.component.html'
})
export class ProjectsShowcaseComponent {}
